import FirstSection from './Components/FirstSection';
import FourthSection from './Components/FourthSection';
import Header from './Components/Header';
import SecondSection from './Components/SecondSection';
import ThirdSection from './Components/ThirdSection';
import FifthSection from './Components/FifthSection';
import SixthSection from './Components/SixthSection';
import Footer from './Components/Footer';
import { useLoadingContext } from './LoadingContext';
import CircularProgress from "@mui/material/CircularProgress";



function App() {
  const { loading, setLoading } = useLoadingContext();

  return (
    <div className="App scroll-smooth bg-[#19295a]">
    {/* <div className="App scroll-smooth bg-[#fff]"> */}
      {loading&&<div className="circular_progress">
        <CircularProgress color="success" />
      </div>}
      <Header />
      <FirstSection />
      <SecondSection />
      <ThirdSection />
      <FourthSection />
      <FifthSection />
      <SixthSection />
      <Footer />
    </div>
  );
}

export default App;
